var forOwn = require('./forOwn');

    /**
     * Get object size
     */
    function size(obj) {
        var count = 0;
        forOwn(obj, function(){
            count++;
        });
        return count;
    }

    module.exports = size;





//////////////////
// WEBPACK FOOTER
// ./node_modules/mout/object/size.js
// module id = 542
// module chunks = 0